export default __webpack_public_path__ + "static/media/deleteIcon.b2f184cd.svg";